import { Kind } from "graphql";
import { extractFragmentNamesFromSelectionSet } from "./field";
export function getFragmentDefinitions(ast) {
    return ast.definitions.filter((def)=>def.kind === Kind.FRAGMENT_DEFINITION);
}
export function collectAllReferencedFragments(fields, fragmentsByName) {
    const collectedNames = new Set();
    for (const field of fields){
        if (field.selectionSet) {
            for (const name of extractFragmentNamesFromSelectionSet(field.selectionSet)){
                collectedNames.add(name);
            }
        }
    }
    const queue = Array.from(collectedNames);
    for(let index = 0; index < queue.length; index++){
        const fragmentName = queue[index];
        const fragmentDefinition = fragmentsByName.get(fragmentName);
        if (typeof fragmentDefinition !== 'undefined') {
            for (const nestedFragmentName of extractFragmentNamesFromSelectionSet(fragmentDefinition.selectionSet)){
                if (!collectedNames.has(nestedFragmentName)) {
                    collectedNames.add(nestedFragmentName);
                    queue.push(nestedFragmentName);
                }
            }
        }
    }
    return Array.from(collectedNames).map((name)=>fragmentsByName.get(name)).filter((fragment)=>typeof fragment !== 'undefined');
}

//# sourceMappingURL=fragment.js.map